import { parseBoolean, parseEnumValue, parseNumber, parseString } from './helpers'

export enum ItemStatus {
  collected = 'collected',
  processing = 'processing',
}

export interface ItemInterface {
  id: string
  title: string
  image_url: string
  status: ItemStatus
  type: string
  location: string
  description: string
  info: string
  order_item_number: string
  erp_code: string
  code: string
  barcode: BarcodeInterface
  quantity_collected: number
  quantity_in_ehu: number
  quantity_total: number
  quantity_stock: number
  measure_unit: string
  is_added?: boolean
}

export interface ItemResponseInterface {
  id: string
  title: string
  image_url: string
  status: string
  type: string
  location: string
  description: string
  info: string
  order_item_number: string
  erp_code: string
  code: string
  barcode: BarcodeInterface
  quantity_collected: number
  quantity_in_ehu: number
  quantity_total: number
  quantity_stock: number
  measure_unit: string
  is_added?: boolean
}

export interface BarcodeInterface {
  main: string
  list: string[]
}

export function parseItemModel(response: ItemResponseInterface): ItemInterface {
  return {
    id: parseString(response?.id),
    title: parseString(response?.title),
    image_url: parseString(response?.image_url),
    type: parseString(response?.type),
    location: parseString(response?.location),
    status: parseEnumValue(ItemStatus, response?.status),
    description: parseString(response?.description),
    info: parseString(response?.info),
    order_item_number: parseString(response?.order_item_number),
    erp_code: parseString(response?.erp_code),
    code: parseString(response?.code),
    barcode: parseBarcodeModel(response?.barcode || null),
    quantity_collected: parseNumber(response?.quantity_collected),
    quantity_in_ehu: parseNumber(response?.quantity_in_ehu),
    quantity_total: parseNumber(response?.quantity_total),
    quantity_stock: parseNumber(response?.quantity_stock),
    measure_unit: parseString(response?.measure_unit),
    is_added: parseBoolean(response?.is_added, false),
  }
}

export function parseBarcodeModel(response: BarcodeInterface | null): BarcodeInterface {
  const list: string[] = []

  if (response && Array.isArray(response.list)) {
    response.list.forEach((item) => {
      if (item) list.push(String(item))
    })
  }

  return {
    main: response?.main ? String(response.main) : '',
    list,
  }
}
